/**
 * OverviewTab — revenue-by-category bars + top items + all-items table.
 * Props: data, maxCatRevenue, goToCategory
 */
import React from 'react';
import { fmt$, fmtN, pct } from '../../../utils/formatUtils';
import TopItemsList from './TopItemsList';
import AllItemsTable from './AllItemsTable';

export default function OverviewTab({ data, maxCatRevenue, goToCategory }) {
  return (
    <div className="sq__pane">
      <div className="sq__ov-grid">
        {/* Revenue by category */}
        <div className="sq__card">
          <div className="sq__card-title">Revenue by Category</div>
          <div className="sq__bar-list">
            {data.categories.slice(0, 12).map(cat => (
              <button key={cat.name} className="sq__bar-row" onClick={() => goToCategory(cat.name)}>
                <div className="sq__bar-head">
                  <span className="sq__bar-name">{cat.name}</span>
                  <div className="sq__bar-meta-right">
                    <span className="sq__bar-rev">{fmt$(cat.revenue)}</span>
                    <span className="sq__bar-meta">
                      {fmtN(cat.itemQty)} items &nbsp;&middot;&nbsp; {fmtN(cat.tickets)} tickets
                      {cat.returnQty > 0 ? ` \u00B7 \u21A9${cat.returnQty}` : ''}
                    </span>
                  </div>
                </div>
                <div className="sq__bar-track">
                  <div className="sq__bar-fill" style={{ width: pct(cat.revenueCents, maxCatRevenue) }} />
                </div>
              </button>
            ))}
            {data.categories.length > 12 && (
              <button className="sq__see-all" onClick={() => goToCategory(data.categories[0]?.name)}>
                See all {data.categories.length} categories \u2192
              </button>
            )}
          </div>
        </div>

        {/* Top items */}
        <div className="sq__card">
          <div className="sq__card-title">Top Items by Quantity</div>
          <TopItemsList categories={data.categories} />
        </div>
      </div>

      {/* All items summary */}
      <div className="sq__card">
        <div className="sq__card-title">All Items This Period</div>
        <AllItemsTable categories={data.categories} />
      </div>
    </div>
  );
}
